import { FC, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import globalStyles from '../../global-styles/rootGlobalStyles';
import { IonButton, IonButtons } from '@ionic/react';
import { DqText } from '../dq-text';
import { FormattedMessage, useIntl } from 'react-intl';
import { JobMessages } from '../../intl/JobMessages';
import { GenericMessages } from '../../intl/GenericMessages';
import './AddAnnotation.css';
import classNames from 'classnames';
import { Input } from '../reusable-components/Input';

export interface AddAnnotationProps {
  /** The currently selected timestamp on the graph. */
  timestamp: number | undefined;
  /** The timezone associated with the job log. */
  timezone: string;
  /** The function to execute when a user saves a new annotation. */
  onSave: (comment: string, timestamp: number | undefined) => void;
}

const useStyles = makeStyles(() => ({
  addAnnotation: {
    flexDirection: 'column',
    display: 'flex',
    paddingTop: globalStyles.Spacing.Three,
  },
  addAnnotationButtonRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: globalStyles.Spacing.One,
    textAlign: 'center',
  },
  timestamp: {
    color: '#66bb6a',
  },
}));

export const AddAnnotation: FC<AddAnnotationProps> = ({ timestamp, timezone, onSave }) => {
  const intl = useIntl();
  const classes = useStyles();
  const [comment, setComment] = useState<string>('');

  const onSaveClick = () => {
    onSave(comment, timestamp);
    setComment('');
  };

  return (
    <div className={classes.addAnnotation}>
      <Input
        label={intl.formatMessage(JobMessages.jobInfoAddAnnotationPlaceholder)}
        placeholder={intl.formatMessage(JobMessages.jobInfoAddAnnotationPlaceholder)}
        value={comment}
        onChange={e => setComment(e.detail.value)}
        id="add-annotation-input"
      />
      <div className={classes.addAnnotationButtonRow}>
        <div>
          {timestamp && (
            <DqText variant="body-strong" className={classNames(classes.timestamp)}>
              ◉ {new Date(timestamp).toLocaleString(intl.locale, { timeZone: timezone, timeZoneName: 'short' })}
            </DqText>
          )}
        </div>
        <IonButtons slot="end">
          <IonButton color="primary" fill="solid" disabled={!comment} onClick={() => onSaveClick()}>
            <FormattedMessage {...GenericMessages.saveButtonLabel} />
          </IonButton>
        </IonButtons>
      </div>
    </div>
  );
};
